import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DescricaoCorFundoContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getDescricaoCorFundo(id: string): Observable<any> {
    return this.getDescricaoCorFundoContents(id).pipe(
      map(res => this.buildResponseDescricaoCorFundoObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryDescricaoCorFundoContents[0].flatData;
  }

  private getDescricaoCorFundoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryDescricaoCorFundoContents(filter: "id eq '${id}'") {
          flatData {
            nome
            descricao
            corTexto
            corFundo
            centralizar
            hasMarginBottom
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseDescricaoCorFundoObject(data: any) {
    return {
      description: data.descricao,
      color: data.corTexto ? data.corTexto : null,
      bgColor: data.corFundo ? data.corFundo : null,
      centerTxt: data.centralizar,
      hasMarginBottom: data.hasMarginBottom
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }

}
